import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { openModal } from '../../../actions/modal';
import { IState } from '../../../reducers';
import VerifySpecialAccess from '../components/VerifySpecialAccessComponent';
import { editEmail, resetSpecialAccessState, verifySpecialAccess } from '../state/actions';
import ISpecialAccessResponse from '../types/ISpecialAccessResponse';

interface IPropsFromState {
    email: string;
    accessData: ISpecialAccessResponse;
    accessDetermined: boolean;
    loading: boolean;
    error?: any;
}

interface IPropsFromDispatch {
    verifySpecialAccess: typeof verifySpecialAccess;
    resetSpecialAccessState: typeof resetSpecialAccessState;
    editEmail: typeof editEmail;
    openModal: typeof openModal;
}

function mapStateToProps(state: IState): IPropsFromState {
    return {
        email: state.specialAccess.email,
        accessData: state.specialAccess.accessData,
        accessDetermined: state.specialAccess.accessDetermined,
        loading: state.specialAccess.loading,
        error: state.specialAccess.error,
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators(
        {
            verifySpecialAccess,
            resetSpecialAccessState,
            editEmail,
            openModal,
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifySpecialAccess);
